// A payload-free signal: no submission data is cached or sent between tabs.
export const SUBMISSION_DATA_CHANGED = 'autoectd:submission-data-changed';

// Some endpoints are POSTs for request-body reasons but are READ-ONLY: they
// compute a hypothetical and mutate nothing. They must never dispatch a
// data-changed refresh. The reorder dialog POSTs
// /api/v1/submissions/reorder/evaluate-lifecycle on open and on every drag; if
// that POST signalled a change, the dashboard would reload, which re-opens /
// re-evaluates the dialog, which POSTs again — a runaway feedback loop
// (observed >400 req/min → 429, status unavailable). The method-based check
// below treats every non-GET as a write, so these read-only POSTs are excluded
// here by path. Matched on the pathname (query string stripped) so a suffix
// match can't be defeated by a trailing `?…`.
const READ_ONLY_POST_PATHS = /\/evaluate-lifecycle$/;

export function notifySubmissionChange(path: string, method = 'GET'): void {
  if (['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase())) return;
  const pathname = path.split('?')[0] ?? path;
  if (READ_ONLY_POST_PATHS.test(pathname)) return;
  if (!/^\/api\/v1\/(submissions|documents|compiler|validation|packages|admin-forms|esg)(\/|$)/.test(pathname)) return;
  window.dispatchEvent(new Event(SUBMISSION_DATA_CHANGED));
}

/** Refresh on writes and return to the app; no status stream or polling timer. */
export function subscribeSubmissionRefresh(refresh: () => void): () => void {
  const visible = (): void => { if (document.visibilityState === 'visible') refresh(); };
  window.addEventListener(SUBMISSION_DATA_CHANGED, refresh);
  window.addEventListener('focus', visible);
  window.addEventListener('online', visible);
  document.addEventListener('visibilitychange', visible);
  return () => {
    window.removeEventListener(SUBMISSION_DATA_CHANGED, refresh);
    window.removeEventListener('focus', visible);
    window.removeEventListener('online', visible);
    document.removeEventListener('visibilitychange', visible);
  };
}
